import React from 'react';

interface DateSelectorProps {
    dates: string[];
    onSelectDate: (date: string) => void;
}

const DateSelector: React.FC<DateSelectorProps> = ({ dates, onSelectDate }) => {
    return (
        <select onChange={(e) => onSelectDate(e.target.value)}>
            {dates.map((date) => (
                <option key={date} value={date}>
                    {date}
                </option>
            ))}
        </select>
    );
};

export default DateSelector;